import { useParams, useSearchParams } from 'react-router';
import useQueryParam from '@jwp/ott-ui-react/src/hooks/useQueryParam';

export default function useSeriesParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const params = useParams();
  const id = params.id || '';
  const play = useQueryParam('play') === '1';
  const feedId = useQueryParam('r');
  const episodeId = useQueryParam('e');

  return {
    seriesId: id,
    play,
    feedId,
    episodeId,
    searchParams,
    setSearchParams,
  };
}
